export default __webpack_public_path__ + "static/popupbanner-ebb9dd430bd6cf854f479a9e351f54bf.png";